module.exports = __webpack_public_path__ + "img/5192686_s.ca84b7e6.jpg";